import ScheduleDataStore from '../../datastores/ScheduleDataStore';

const data = {
  student: {
    schedule: {
      items: [
        {
          weekId: 16,
          start: 1660521600000,
          end: 1660521600000,
          id: '013776_1625841900000_1625847300000',
          name: 'MATEMATICA LUIS',
          desc: 'MATEMATICA LUIS',
          type: 'COURSE',
          classType: '2',
          location: {
            classRoom: {
              id: 'A0402',
              desc: 'Teoría Presencial',
              floor: 4,
              __typename: 'ScheduleClassRoom'
            },
            building: {
              id: 'C_CHICLAYO',
              desc: 'Chiclayo',
              image: 'Chiclayo.jpg',
              address: 'Esquina Prol. Augusto B. Leguía con Av. Herman Meiner',
              coordinates: {
                latitude: -79.863446,
                longitude: -6.763529,
                __typename: 'ScheduleCoordinates'
              },
              __typename: 'ScheduleBuilding'
            },
            __typename: 'ScheduleLocation'
          },
          linkZoom: 'www.google.com',
          idZoom: 'www.google.com',
          instructionMode: 'A',
          hours: 4,
          isReprog: true,
          __typename: 'ScheduleItem'
        },
        {
          weekId: 16,
          start: 1662588030000,
          end: 1662593430000,
          id: '013776_1625841900000_1625847300000',
          name: 'COMPRENSION LUIS F',
          desc: 'COMPRENSION Y REDACCION DE TEXTOS I',
          type: 'COURSE',
          classType: '1',
          location: {
            classRoom: {
              id: 'A0402',
              desc: 'Teoría Presencial',
              floor: 4,
              __typename: 'ScheduleClassRoom'
            },
            building: {
              id: 'C_CHICLAYO',
              desc: 'Chiclayo',
              image: 'Chiclayo.jpg',
              address: 'Esquina Prol. Augusto B. Leguía con Av. Herman Meiner',
              coordinates: {
                latitude: -79.863446,
                longitude: -6.763529,
                __typename: 'ScheduleCoordinates'
              },
              __typename: 'ScheduleBuilding'
            },
            __typename: 'ScheduleLocation'
          },
          instructionMode: 'R',
          hours: 4,
          isReprog: true,
          __typename: 'ScheduleItem'
        },
        // {
        //   weekId: 16,
        //   start: 1663011000000,
        //   end: 1663007400000,
        //   id: '013776_1663011000000_1663007400000',
        //   name: 'TALLER DE ABEL',
        //   desc: 'TALLER DE ABEL',
        //   type: 'COURSE',
        //   classType: '3',
        //   location: {
        //     classRoom: {
        //       id: 'A04023',
        //       desc: 'Teoría Presencial',
        //       floor: 4,
        //       __typename: 'ScheduleClassRoom'
        //     },
        //     building: {
        //       id: 'C_CHICLAYO',
        //       desc: 'Chiclayo',
        //       image: 'Chiclayo.jpg',
        //       address: 'Esquina Prol. Augusto B. Leguía con Av. Herman Meiner',
        //       coordinates: {
        //         latitude: -79.863446,
        //         longitude: -6.763529,
        //         __typename: 'ScheduleCoordinates'
        //       },
        //       __typename: 'ScheduleBuilding'
        //     },
        //     __typename: 'ScheduleLocation'
        //   },
        //   linkZoom: 'www.google.com',
        //   idZoom: 'www.google.com',
        //   instructionMode: 'P',
        //   isReprog: false,
        //   hours: 4,
        //   __typename: 'ScheduleItem'
        // },
        {
          weekId: 16,
          start: 1645016400000,
          end: 1645023600000,
          id: '013776_1625841900000_1625847300000',
          name: 'TALLER DE SOFTWARE I',
          desc: 'TALLER DE SOFTWARE I',
          type: 'COURSE',
          classType: '1',
          location: {
            classRoom: {
              id: 'A0402',
              desc: 'Teoría Presencial',
              floor: 4,
              __typename: 'ScheduleClassRoom'
            },
            building: {
              id: 'C_CHICLAYO',
              desc: 'Chiclayo',
              image: 'Chiclayo.jpg',
              address: 'Esquina Prol. Augusto B. Leguía con Av. Herman Meiner',
              coordinates: {
                latitude: -79.863446,
                longitude: -6.763529,
                __typename: 'ScheduleCoordinates'
              },
              __typename: 'ScheduleBuilding'
            },
            __typename: 'ScheduleLocation'
          },
          instructionMode: 'P',
          hours: 4,
          isReprog: false,
          __typename: 'ScheduleItem'
        },
        {
          weekId: 16,
          start: 1671523236000,
          end: 1671530436000,
          id: '013776_1625841900000_1625847300000',
          name: 'TALLER DE SOFTWARE II F',
          desc: 'TALLER DE SOFTWARE II F',
          type: 'COURSE',
          classType: '4',
          location: null,
          classRoom: {
            id: 'A0402',
            desc: 'Teoría Presencial',
            floor: 4,
            __typename: 'ScheduleClassRoom'
          },
          building: null,
          instructionMode: 'R',
          hours: 4,
          isReprog: false,
          __typename: 'ScheduleItem'
        },
        {
          weekId: 16,
          start: 1671634808000,
          end: 1671642008000,
          id: '013779_1625841900000_1625847300000',
          name: 'TALLER DE SOFTWARE III',
          desc: 'TALLER DE SOFTWARE III',
          type: 'COURSE',
          classType: '4',
          location: null,
          classRoom: {
            id: 'A0402',
            desc: 'Teoría Presencial',
            floor: 4,
            __typename: 'ScheduleClassRoom'
          },
          building: null,
          instructionMode: 'R',
          hours: 4,
          isReprog: false,
          __typename: 'ScheduleItem'
        }
      ]
    }
  }
};

const data2 = {
  student: {
    schedule: {
      items: [
        {
          weekId: 1,
          start: 1708006500000,
          end: 1708014600000,
          id: '018399_1707988500000_1707996600000',
          name: 'INTRODUCCION A LA ADMINISTRACION',
          isClass: true,
          desc: 'INTRODUCCION A LA ADMINISTRACION',
          type: 'COURSE',
          classType: '5',
          instructionMode: 'R',
          isReprog: false,
          location: {
            classRoom: {
              id: '56AV470'
            }
          }
        },
        {
          weekId: 2,
          start: 1708027200000,
          end: 1708038000000,
          id: '018400_1708009200000_1708020000000',
          name: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: ADMINISTRACIÓN Y NEGOCIOS',
          isClass: true,
          desc: 'INTRODUCCIÓN A LA VIDA UNIVERSITARIA: ADMINISTRACIÓN Y NEGOCIOS',
          type: 'COURSE',
          classType: '5',
          instructionMode: 'R',
          isReprog: false,
          location: {
            classRoom: {
              id: '56AV474'
            }
          }
        }
      ]
    }
  }
};

export default class ScheduleDataStoreMock implements ScheduleDataStore {
  getScheduleResumeHome() {
    return data.student;
  }

  async getSchedule() {
    return data.student;
  }

  async getScheduleByDay() {
    return data2.student.schedule;
  }
}
